import React from 'react'
import { Button, ButtonProps } from 'antd'
import { useTranslation } from 'react-i18next'
import { trackButtonClick } from '../../../utils/gtmUtils'

interface AppleStoreButtonProps extends Omit<ButtonProps, 'onClick'> {
    url?: string
    iconClassName?: string
    location?: string
}

const AppleStoreButton: React.FC<AppleStoreButtonProps> = ({
    url = 'https://apps.apple.com/us/app/dailyvents/id6447474654',
    type = 'default',
    size = 'large',
    className,
    iconClassName,
    location = 'unknown',
    ...rest
}) => {
    const { t } = useTranslation()

    const handleClick = () => {
        trackButtonClick('apple_store', location, {
            url,
        })
        window.open(url, '_blank')
    }

    return (
        <Button
            type={type}
            size={size}
            className={className}
            onClick={handleClick}
            {...rest}
        >
            <span className={iconClassName}>
                <img
                    src="/img/Apple_logo.svg"
                    alt={t('common.alt.appleStore')}
                />
            </span>
            App Store
        </Button>
    )
}

export default AppleStoreButton
